(() => {
const $3c396acd1504d2ab$export$86d305fa3a62f93b = ()=>{
    if (!localStorage.getItem('visitorRegion') || !localStorage.getItem('visitorCountry')) return fetch(calendlyData.regionApiUrl + '/api/public/v1/region').then((res)=>res.json()).then((data)=>{
        localStorage.setItem('visitorRegion', data.region.toLowerCase());
        localStorage.setItem('visitorCountry', data.country.toLowerCase());
    });
};
const $3c396acd1504d2ab$export$f0b84f02ed496d9 = (value)=>{
    const values = value.replaceAll(' ', '').split(',');
    return values;
};


const $54563478cb4348b0$var$selectors = {
    demo: '.mp-demo',
    page: '.mp-demo__page',
    backBtn: 'button#demo-back',
    nextBtn: 'button#demo-next',
    filter: '.mcfly-options',
    calendlyForm: '.mp-calendly'
};
const $54563478cb4348b0$var$classNames = {
    pageOpen: 'open'
};
const $54563478cb4348b0$var$stateUpdateEvent = 'demoStateUpdate';
const $54563478cb4348b0$var$showComponent = async (el)=>{
    await (0, $3c396acd1504d2ab$export$86d305fa3a62f93b)();
    const vRegion = localStorage.getItem('visitorRegion');
    const vCountry = localStorage.getItem('visitorCountry');
    let show = false;
    const targetRegions = el.getAttribute('data-regions') ? (0, $3c396acd1504d2ab$export$f0b84f02ed496d9)(el.getAttribute('data-regions')) : [];
    const excludedCountries = el.getAttribute('data-excluded-countries') ? (0, $3c396acd1504d2ab$export$f0b84f02ed496d9)(el.getAttribute('data-excluded-countries')) : [];
    const targetCountries = el.getAttribute('data-countries') ? (0, $3c396acd1504d2ab$export$f0b84f02ed496d9)(el.getAttribute('data-countries')) : [];
    if (targetRegions.length) // The form should be visible for visitors from one or multiple regions
    {
        if (targetRegions.includes(vRegion) && !excludedCountries.includes(vCountry)) show = true;
    } else if (targetCountries.length) // The form should be visible for visitors from one or multiple countries
    {
        if (targetCountries.includes(vCountry)) show = true;
    } else // The form should be visible for every visitor
    show = true;
    return show;
};
document.querySelectorAll($54563478cb4348b0$var$selectors.demo).forEach(async (demo)=>{
    if (await $54563478cb4348b0$var$showComponent(demo)) {
        // Show.
        demo.hidden = false;
        const filter = demo.querySelector($54563478cb4348b0$var$selectors.filter);
        const nextBtn = demo.querySelector($54563478cb4348b0$var$selectors.nextBtn);
        const backBtn = demo.querySelector($54563478cb4348b0$var$selectors.backBtn);
        const state = {
            page: 1,
            totalPages: demo.querySelectorAll($54563478cb4348b0$var$selectors.page).length,
            option: {}
        };
        const updateFilterState = ()=>{
            const filterValue = filter.getAttribute('data-value');
            if (filterValue) {
                const [accountID, eventID] = filterValue.split('|');
                state.option = {
                    accountID: accountID,
                    eventID: eventID
                };
            }
        };
        const handleNavigationVisibility = ()=>{
            backBtn.hidden = 1 === state.page;
            nextBtn.hidden = state.page === state.totalPages;
            // Check if the user is allowed to continue.
            const activeOption = demo.querySelector($54563478cb4348b0$var$selectors.filter).getAttribute('data-value');
            nextBtn.disabled = activeOption === '';
        };
        const updatePageContent = ()=>{
            // Show / Hide Calendly form(s).
            if (2 === state.page) demo.querySelectorAll($54563478cb4348b0$var$selectors.calendlyForm).forEach((form)=>{
                const matchAccountID = form.getAttribute('data-account-link') === state.option.accountID;
                const matchEventID = form.getAttribute('data-event-link') === state.option.eventID;
                form.hidden = !(matchAccountID && matchEventID);
            });
            // Open new page.
            const openPage = demo.querySelector(`${$54563478cb4348b0$var$selectors.page}.${$54563478cb4348b0$var$classNames.pageOpen}`);
            const targetPage = demo.querySelector(`${$54563478cb4348b0$var$selectors.page}:nth-of-type(${state.page})`);
            if (targetPage && targetPage !== openPage) {
                openPage.classList.remove($54563478cb4348b0$var$classNames.pageOpen);
                targetPage.classList.add($54563478cb4348b0$var$classNames.pageOpen);
            }
        };
        demo.addEventListener($54563478cb4348b0$var$stateUpdateEvent, ()=>{
            updateFilterState();
            updatePageContent();
            handleNavigationVisibility();
        });
        // Navigation.
        nextBtn.addEventListener('click', ()=>{
            state.page = state.page + 1;
            demo.dispatchEvent(new CustomEvent($54563478cb4348b0$var$stateUpdateEvent));
        });
        backBtn.addEventListener('click', ()=>{
            state.page = state.page - 1;
            demo.dispatchEvent(new CustomEvent($54563478cb4348b0$var$stateUpdateEvent));
        });
        // Options.
        filter.addEventListener('click', ()=>{
            demo.dispatchEvent(new CustomEvent($54563478cb4348b0$var$stateUpdateEvent));
        });
        // Initial check.
        demo.dispatchEvent(new CustomEvent($54563478cb4348b0$var$stateUpdateEvent));
    } else demo.remove();
    // Listen for color scheme changes
    document.addEventListener('colorModeChange', (e)=>{
        demo.setAttribute('data-color-scheme', e.detail);
    });
});

})();
//# sourceMappingURL=demo.min.js.map
